import React from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

import { useRemoveParticipantFromFriendsGroupMutation } from '@/api/queries/group';
import { H2 } from '@/components/Typography/Typography';

interface prop {
  participantId: string;
  active: boolean;
  setOpen: (e: boolean) => void;
}

const Window: React.FC<prop> = ({ participantId, active, setOpen }) => {
  const [removeParticipant] = useRemoveParticipantFromFriendsGroupMutation();
  const { t } = useTranslation();

  return (
    <div className={`modalUpdateBackground ${active ? 'open' : ''}`}>
      <CSSTransition
        in={active}
        timeout={300}
        classNames="newGroupWindow-modal"
        unmountOnExit
      >
        <div className="newGroup">
          <div className="newGroupWindow">
            <H2>{t('Removing')}</H2>
            <p className="pemovingParagraf">
              {t('Remove this friend from the group?')}
            </p>
            <div>
              <button
                type="button"
                className="btn btn-dark"
                onClick={() => setOpen(false)}
              >
                {t('Cancel')}
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => {
                  setOpen(false);
                  removeParticipant({ participantId });
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Window;
